import gen from '../gen'
var ls = require('local-storage');
//
const state = {
  googleCloudVisionAPI_landmarkSuggestion: [],
  googleCloudVisionAPI_labelSuggestion: []
}

const getters = {
  googleCloudVisionAPI_landmarkSuggestion: state => state.googleCloudVisionAPI_landmarkSuggestion,
  googleCloudVisionAPI_labelSuggestion: state => state.googleCloudVisionAPI_labelSuggestion
}

const mutations = {
  //
  googleCloudVisionAPI_labelNLandmarkSuggestion_byImgUrl(state2, payload){
    //
    let imageUrl = payload.imageUrl
    //
    gen
      .actions
      .axiosPostReq(state, {
        url : 'https://vision.googleapis.com/v1/images:annotate?key=AIzaSyDp9pMMMo8Yiy13OwDbZnO2BY_1qwQSEn0',
        obj : { // request
          "requests": [
            {
              "image": {
                "source": {
                  "imageUri": imageUrl
                }
              },
              "features": [
                {
                  "type": "LANDMARK_DETECTION"
                },
                {
                  "type": "LABEL_DETECTION"
                }
              ]
            }
          ]
        }
      }).then((response)=>{
        //
        let result = response.data.responses[0]
        // console.log("#########[GOOGLE VISION API]#########", result)
        //
        let googleAPISuggestion_labels = result.labelAnnotations
        // console.log("1", googleAPISuggestion_labels)
        //
        let googleAPISuggestion_landmarks = result.landmarkAnnotations
        // console.log("2", googleAPISuggestion_landmarks)
        //
        //
        // console.log("label => " + googleAPISuggestion_labels + " | " + undefined)
        if(googleAPISuggestion_labels != undefined) {
          //
          let labelArr = []
          for(let i in googleAPISuggestion_labels){
            // console.log(googleAPISuggestion_labels[i].description)
            labelArr.push(googleAPISuggestion_labels[i].description)
          }
          //
          ls.set('googleVisionAPI_labelSuggestion', JSON.stringify(labelArr))
          setTimeout(()=>{
            console.log("[G]", JSON.parse(ls.get('googleVisionAPI_labelSuggestion')))
          },1000)
        }
        //
        // console.log("landmarks => " + googleAPISuggestion_landmarks + " | " + undefined)
        if(googleAPISuggestion_landmarks != undefined) {
          //
          let landmarkArr = []
          for(let i in googleAPISuggestion_landmarks){
            // console.log(googleAPISuggestion_landmarks[i].description)
            landmarkArr.push(googleAPISuggestion_landmarks[i].description)
          }
          //
          ls.set('googleVisionAPI_landmarkSuggestion', JSON.stringify(landmarkArr))
          // setTimeout(()=>{
          //   console.log("[G]", JSON.parse(ls.get('googleVisionAPI_landmarkSuggestion')))
          // },1000)
        }
    })
  },
  //
  setEmptyVar_ls(state2){
    //
    ls.set('googleVisionAPI_landmarkSuggestion', //saving response in local storage => landmark
      JSON.stringify([]));
    //
    ls.set('googleVisionAPI_labelSuggestion', //saving response in local storage => label
      JSON.stringify([]));
    //
    ls.set('imaggaSuggestions', //saving response in local storage => imagga, label
      JSON.stringify([]));
  }
}

const actions = {
  //
  //
}

export default{
  state,
  getters,
  mutations,
  actions
}



// WEBPACK FOOTER //
// ./src/store/modules/uploadImage/googleCloudVisionAPI.js